if (!customElements.get('trust-indicators-slider')) {
  class TrustIndicatorsSlider extends HTMLElement {
    constructor() {
      super();

      const swiperOptions = JSON.parse(this.getAttribute('data-swiper-options')) || {};

      if (Shopify.designMode) {
        window.addEventListener('shopify:section:load', e => {
          this.initSlider(swiperOptions);
        });
      }

      this.initSlider(swiperOptions);
    }

    initSlider(swiperOptions) {
      this.slider = new Swiper(this, {
        slidesPerView: 1,

        pagination: {
          el: ".trust-indicators--progressbar",
          type: 'bullets',
          //type: 'progressbar',
        },

        autoplay: swiperOptions.autoplay || false,

        spaceBetween: swiperOptions.spaceBetweenMobile || 2,
        breakpoints: {
          750: {
            enabled: true,
            spaceBetween: swiperOptions.spaceBetweenDesktop || 2,
            slidesPerView: 2,
            loop: false
          },
          990: {
            enabled: true,
            spaceBetween: swiperOptions.spaceBetweenDesktop || 0,
            slidesPerView: swiperOptions.slidesPerView || 2,
            loop: false
          }
        }
      });
    }
  }

  customElements.define('trust-indicators-slider', TrustIndicatorsSlider);
}
